export const galleyImageOptions = {
  angle: 'galley',
  staticOptions: {
    Veneer: 1,
    Floorboard: 1,
    Handrail: 1,
    Worktop: 1,
    Fabric: 1,
    CupboardsSaloon: 1,
    CupboardsOwnersCabin: 1,
    FabricCabins: 1,
    AftCabinLayout: 1,
    Mast: 1
  },
  mattes: [
    {
      option: 'Veneer',
      dependency: null
    },
    {
      option: 'Handrail',
      dependency: 'Veneer'
    },
    {
      option: 'Worktop',
      dependency: null
    },
    {
      option: 'Fabric',
      dependency: 'Worktop'
    },
    {
      option: 'CupboardsSaloon',
      dependency: 'Veneer'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/X40/views/galley.js